import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

let _countries;

function init() {
}

function getCountries() {
    return $.Deferred(function(def) {
        if (_countries)
            return def.resolve(_countries);
        dataaccess.get({ url: "/api/locale/country" }).done(function(result) {
            _countries = result;
            return def.resolve(_countries);
        });
    }).promise();
}

function populateCountriesSelect(countrySelect, stateSelectContainerDiv) {
    return $.Deferred(function(def) {
        getCountries().done(function(countries) {
            for (let i = 0; i < countries.length; i++) {
                $(countrySelect).append("<option countryId=\"" + countries[i].id + "\" value=\"" +
                    countries[i].abbreviation +
                    "\">" +
                    countries[i].name +
                    "</option>");
            }
            $(stateSelectContainerDiv).find("select").attr("disabled", "disabled");
            def.resolve();
        });
    });
}

function populateStatesSelect(stateSelectContainerDiv, nonNaStateInput, countryValue) {
    return $.Deferred(function(def) {
        $(stateSelectContainerDiv)
            .find("option")
            .not(":first")
            .remove()
            .end();
    
        getCountries().done(function(countries) {
            if (!countryValue || countryValue === "") {
                $(stateSelectContainerDiv).removeClass("hidden");
                $(stateSelectContainerDiv).find("select").attr("disabled", "disabled");
            }
            for (let i = 0; i < countries.length; i++) {
                if (countries[i].abbreviation !== countryValue) continue;
    
                if (!countries[i].hasStatesOrProvinces) {
                    $(stateSelectContainerDiv + " option:selected").removeAttr("selected");
                    $(stateSelectContainerDiv).find("select").prop("disabled", true).addClass("hidden");
                    $(stateSelectContainerDiv).find(nonNaStateInput).removeClass("hidden").val("");
                    $(stateSelectContainerDiv).parent().find(nonNaStateInput).removeClass("hidden").val("");
                    break;
                } else {
                    $(stateSelectContainerDiv).removeClass("hidden");
                    $(stateSelectContainerDiv).find("select").prop("disabled", false).removeClass("hidden");
                    $(stateSelectContainerDiv).find(nonNaStateInput).addClass("hidden").val("");
                    $(stateSelectContainerDiv).parent().find(nonNaStateInput).addClass("hidden").val("");
                }
                for (let j = 0; j < countries[i].states.length; j++) {
                    $(stateSelectContainerDiv).find("select")
                        .append("<option value=\"" +
                            countries[i].states[j].id +
                            "\">" +
                            countries[i].states[j].name +
                            "</option>");
                }
                break;
            }
            def.resolve();
        });
    });
}

export const countryState = {
    init: init,
    getCountries: getCountries,
    populateCountriesSelect: populateCountriesSelect,
    populateStatesSelect: populateStatesSelect
};